import { KYMW2100Model } from '../kymw2100.model';
import { SearchConditionOfOrderNumModel } from '../vo/search-condition-of-order-num.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 注文コード一覧取得するサービス
 *
 * @export GetOrderNumListService
 * @class GetOrderNumListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetOrderNumListService extends PlessJsonResponderSub<any> {

  private model: KYMW2100Model;
  private vo = new SearchConditionOfOrderNumModel();

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetOrderNumListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.OrderCode,
        MediumType: this.vo.MediumType,
        CoopCode: this.vo.CoopCode,
        PCode: this.vo.PCode,
        OrderNumFrom: this.vo.OrderNumFrom,
        OrderNumTo: this.vo.OrderNumTo,
        PageNumFrom: this.vo.PageNumFrom,
        PageNumTo: this.vo.PageNumTo
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetOrderNumListService
   */
  execute(model: KYMW2100Model, vo: SearchConditionOfOrderNumModel): void {
    this.model = model;
    this.vo = vo;
    this.send('getOrderNumList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetOrderNumListService
   */
  success(data: any): void {
    if (data !== null) {
      // データグリッド「注文コード一覧」を更新
      this.model.updateOrderNumList(data, this.vo);
      // ボタン「設定」、「リセット」の活性状態を設定する
      this.model.kymw2100Component.setSetButtonEnabled();
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {*} errList レスポンスデータ
   * @memberof GetOrderNumListService
   */
  public plessErrorHandler(errList: Object): void {
    //  企画ロックを解除する
    this.model.kymw2100Component.releaseLockInfoCatalog();
    // 標準処理を続行
    super.plessErrorHandler(errList);
  }

  /**
   * システムエラー時のメソッド
   * @param errList サーバ受信データ
   *  機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public systemErrorHandler(errList: Object): void {
    //  企画ロックを解除する
    this.model.kymw2100Component.releaseLockInfoCatalog();
    // 標準処理を続行
    super.systemErrorHandler(errList);
  }
}
